module.exports = __webpack_public_path__ + "img/Sandemose_Aksel_og_Hanne.da2f28eb.jpg";